import $ from 'jquery'

export default {
    name: 'antecedent-allergologie-personnel',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_physio: true,

            save_loading: false,

            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'mode_accouchement', 'reanimation', 'reanimation_duree',
                'poids_naissance', 'poids_unit', 'mode_allaitement',
                'croissance_bien_suivi', 'croissance_justif', 'dpm_harmonieux',
                'dpm_justif', 'alimentation_equlibree', 'alimentation_non_equlibree', 'supplementation_fer', 'supplementation_acide_folique',
                'supplementation_vit', 'atcd_allergo_physio_autre', 'patho_medicaux',
                'patho_asthme', 'patho_asthme_mention', 'patho_allergie',
                'patho_allergie_mention', 'patho_atopie', 'patho_atopie_mention'
            ],
        }
    },
    computed: {
        antecedent_allergo_personnel() {
            return this.$store.getters["antecedent_allergo_personnel"];
        },
    },
    mounted() {
        this.listeChampATCDAllergoPersonnel()
    },
    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_allergo_personnel.length > 0) {
                    v = this.antecedent_allergo_personnel[index]['field_content']
                } else {
                    if (fld == 'poids_unit') {
                        v = 'Kg'
                    }
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        async listeChampATCDAllergoPersonnel() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_personnel',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        toggleSection() {
            this.is_physio = (this.is_physio)?false:true
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        saveAntecedent() {
            this.save_loading = true

            console.log(this.atcd_allergo_p)

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_personnel',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDAllergoPersonnel()
                }

                this.save_loading = false
            })
        }
    }
}


